module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/guestlist_desktop-63dcd39ebb579a9124101198aa017bab.png";